import React from 'react';

const ActionsLine = () => {
  return (
    <svg width="264" height="32" viewBox="0 0 264 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="48" y="6" width="216" height="8" fill="#E6E9EC" />
      <rect x="48" y="22" width="32" height="4" fill="#E6E9EC" />
      <circle cx="16" cy="16" r="16" fill="#E6E9EC" />
    </svg>
  );
};

export default ActionsLine;
